<script>
import { createHelpers } from 'vuex-map-fields'
import { mapState } from 'vuex'
import { TrashIcon } from "@/icons";
import AWS from 'aws-sdk';
import BackToSettings from "@/views/settings/BackToSettings.vue";
import PageHeader from "@/views/payouts/components/PageHeader.vue";
import { IconNewTab } from '@/icons'
var Nanobar = require('../../../../node_modules/nanobar/nanobar');
const nanobar = new Nanobar()

const { mapFields } = createHelpers({
  getterType: 'marketplace/getField',
  mutationType: 'marketplace/updateField'
})

export default {
  name: 'MarketplaceSettings',

  data() {
    return {
      bucketName: 'coco-profile-images',
      loading: false,
      loadingProfile: false,
      filesToUpload: [],
      previewProfile: false,
      rules: {
        required: value => !!value || 'This field is required',
        url: value => {
          const pattern  = /^((([A-Za-z]{3,9}:(?:\/\/)?)(?:[\-;:&=\+\$,\w]+@)?[A-Za-z0-9\.\-]+|(?:www\.|[\-;:&=\+\$,\w]+@)[A-Za-z0-9\.\-]+)((?:\/[\+~%\/\.\w\-_]*)?\??(?:[\-\+=&;%@\.\w_]*)#?(?:[\.\!\/\\\w]*))?)/
          return pattern.test(value) || 'Please enter a valid URL starting with https://'
        },
        urlNotRequired: value => {
          if(value) {
            const pattern  = /^((([A-Za-z]{3,9}:(?:\/\/)?)(?:[\-;:&=\+\$,\w]+@)?[A-Za-z0-9\.\-]+|(?:www\.|[\-;:&=\+\$,\w]+@)[A-Za-z0-9\.\-]+)((?:\/[\+~%\/\.\w\-_]*)?\??(?:[\-\+=&;%@\.\w_]*)#?(?:[\.\!\/\\\w]*))?)/
            return pattern.test(value) || 'Please enter a valid URL starting with https://'
          }

          return true
        }
      },
      s3: {
        accessKeyId: 'AKIARBS6AYWAYYCXNOPR',
        secretAccessKey: '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',
        region: 'ap-southeast-1',
      },
      settings: {
        category: null,
        coco_profile_images: [],
        images: [],
        location: null,
        num_of_products: null,
        social_media: '',
        brand_name: null,
        website: null,
      },
      unMutatedSetting: null,
      validForm: false,
      model: 0,
      previewProfileImages: [],
      loadingPreview: false
    }
  },

  components: {
    BackToSettings,
    IconNewTab,
    PageHeader,
    TrashIcon,
  },

  async created() {
    try {
      this.loadingProfile = true
      nanobar.go(this.randomNumber(20, 90))
      await this.$store.dispatch('shop/init')
      await this.$store.dispatch('plan/init', this.user.id)
      await this.fetchProfileHandler()
      nanobar.go(100)
      this.loadingProfile = false
    } catch(error) {
      nanobar.go(100)
      this.loadingProfile = false
    }
  },

  computed: {
    ...mapState('auth', ['user']),
    ...mapState('shop', ['currentShop']),
    ...mapFields([
      'categories',
      'countries',
      'profile',
      'maxImagesAllowed',
    ]),
  },

  methods: {
    randomNumber(min, max){
      const r = Math.random()*(max-min) + min
      return Math.floor(r)
    },

    handleFileUpload() {
      const files = [...this.$refs.fileInput.files];
      const { images, coco_profile_images } = this.settings
      const totalFiles = files.length + images.length + coco_profile_images.length;
      const totalFilesAllowed = this.maxImagesAllowed - (images.length + coco_profile_images.length)

      if(totalFiles > this.maxImagesAllowed) {
        alert(`You can add up to ${this.maxImagesAllowed} images`)
        files.length = totalFilesAllowed
      }

      this.filesToUpload = [...files];
      this.uploadFilesToS3Handler()
    },

    async uploadFilesToS3Handler() {
      let _this = this
      try {
        this.loading = true;
        const s3 = new AWS.S3({ ..._this.s3 });
        const promises = this.filesToUpload.map(async (file) => {
          const fileContent = await file.arrayBuffer();
          const params = {
            Bucket: _this.bucketName,
            Key: `${_this.currentShop.store_domain}/${file.name}_${Math.random()*(99999-9999) + 9999}`,
            Body: fileContent,
          };
          return s3.upload(params).promise();
        });

        const res = await Promise.all(promises);
        res.forEach(image => {
          _this.settings.images = [..._this.settings.images, image]
        })
      } catch (err) {
        console.log(err)
      } finally {
        this.loading = false;
      }
    },

    async deleteFilesFromS3Handler(image, index) {
      let _this = this
      try {
        this.loading = true;
        const s3 = new AWS.S3({ ..._this.s3 });
        const params = {
          Bucket: _this.bucketName,
          Key: image.Key || image.key,
        };

        await s3.deleteObject(params).promise();
        _this.settings.images.splice(index, 1)
      } catch (err) {
        console.log(err);
      } finally {
        this.loading = false;
      }
    },

    deleteFilesFromView(index) {
      this.settings.coco_profile_images.splice(index, 1)
    },

    previewProfileHandler() {
      this.loadingPreview = true
      const { coco_profile_images, images } = this.settings;
      this.previewProfileImages = Array.from(
        new Set([
          ...coco_profile_images.map((image) => image.image_url),
          ...images.map((image) => image.Location || image.location),
        ])
      );

      setTimeout(() => {
        this.previewProfile = true
        this.loadingPreview = false
      }, 500)
    },

    async fetchProfileHandler() {
      await this.$store.dispatch('marketplace/fetchProfile', this.currentShop.id)
      const { location, brand_name, updated_at } = this.profile

      if(updated_at) {
        this.settings = { ...this.settings, ...this.profile }
      } else {
        this.settings.brand_name = this.currentShop.store_domain
        this.settings.location = location.country
      }

      if(!brand_name) {
        this.settings.brand_name = this.currentShop.store_domain
      }
    },

    validateUrl(url) {
      if(!url) return
      if (!url.startsWith('http://') && !url.startsWith('https://')) {
        url = `https://${url}`
      }

      return url
    },

    async saveProfileHandler() {
      const isFormValid = this.$refs.profileForm.validate()
      if (!isFormValid) return

      const {
        brand_name,
        category,
        coco_profile_images,
        coco_social_media,
        images,
        location,
        num_of_products,
        social_media,
        website,
      } = this.settings;

      const country = (location.id && location.country) ? location.country : location
      let instagram_url = (coco_social_media && coco_social_media[0]) ? coco_social_media[0].url : social_media

      const allImageURLs = Array.from(
        new Set([
          ...coco_profile_images.map((image) => image.image_url),
          ...images.map((image) => image.Location || image.location),
        ])
      );

      instagram_url = this.validateUrl(instagram_url)
      this.settings.website = this.validateUrl(website)

      const payload = {
        brand_name,
        category,
        images: allImageURLs,
        location: {
          city: '-',
          country,
        },
        num_of_products,
        instagram_url,
        website: this.settings.website,
      }

      this.loadingProfile = true
      await this.$store.dispatch('marketplace/updateProfile', { payload, storeId: this.currentShop.id })
      await this.fetchProfileHandler()
      this.loadingProfile = false
      this.settings.images = []
    }
  }
}
</script>

<template>
  <section class="v2 marketplace-settings">
    <BackToSettings />

    <!-- Page Header -->
    <div class="relative">
      <PageHeader pageDescription="">
        <template #title>Marketplace settings</template>
      </PageHeader>

      <div class="absolute actions d-flex">
        <p v-if="profile && profile.updated_at" style="font-size: 12px; transform: translateY(19px); color: rgba(118, 118, 118, 1);">
          Last saved {{ profile.updated_at | moment('MMM DD') }}, {{ profile.updated_at | moment('hh:mm A') }}
        </p>
        <v-btn elevation="0" class="btn btn-border lg m-l-2" :disabled="loading" :loading="loadingPreview" @click="previewProfileHandler">Preview</v-btn>
        <v-btn elevation="0" class="btn btn-border inverse lg m-l-1" @click="saveProfileHandler" :loading="loadingProfile" :disabled="loading">Save</v-btn>
      </div>
    </div>

    <h4 class="p-t-3 m-t-3" style="border-top: solid 1px #E0E0E0;">Profile details</h4>

    <v-form v-model="validForm" ref="profileForm" class="m-t-4">
      <v-row>
        <v-col cols="6">
          <label>Brand name</label>
        </v-col>
        <v-col cols="6">
          <v-text-field
            :rules="[rules.required]"
            background-color="#fff"
            dense
            outlined
            v-model="settings.brand_name"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="6">
          <label>Instagram <span style=" font-weight: 400;">(Optional)</span></label>
        </v-col>
        <v-col cols="6">
          <v-text-field
            :rules="[rules.urlNotRequired]"
            background-color="#fff"
            dense
            outlined
            placeholder="Enter your Instagram URL"
            v-if="settings.updated_at && settings.coco_social_media[0]"
            v-model="settings.coco_social_media[0].url"
          />
          <v-text-field
            :rules="[rules.urlNotRequired]"
            background-color="#fff"
            dense
            outlined
            placeholder="Enter your Instagram URL"
            v-else
            v-model="settings.social_media"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="6">
          <label>Website</label>
        </v-col>
        <v-col cols="6">
          <v-text-field
            :rules="[rules.required, rules.url]"
            background-color="#fff"
            dense
            outlined
            v-model="settings.website"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="6">
          <label>Location</label>
        </v-col>
        <v-col cols="6">
          <v-autocomplete
            :items="countries"
            :menu-props="{ 'content-class': 'select-menu' }"
            :rules="[rules.required]"
            background-color="#fff"
            clearable
            dense
            item-text="name"
            item-value="country"
            label="Select Country"
            outlined
            v-model="settings.location"
          />
        </v-col>
      </v-row>

      <v-row class="p-t-3">
        <v-col cols="6">
          <label>Store category</label>
          <p style="color: #767676; font-weight: 400;" class="m-t-1 m-b-0">The primary category of <br> products you sell</p>
        </v-col>
        <v-col cols="6">
          <v-select
            :items="categories"
            :menu-props="{ 'content-class': 'select-menu' }"
            :rules="[rules.required]"
            background-color="#fff"
            clearable
            dense
            label="Select category"
            outlined
            v-model="settings.category"
          />
        </v-col>
      </v-row>

      <v-row class="p-y-3">
        <v-col cols="6">
          <label>Number of products</label>
        </v-col>
        <v-col cols="6">
          <v-text-field
            :rules="[rules.required]"
            background-color="#fff"
            dense
            outlined
            type="number"
            v-model="settings.num_of_products"
          />
        </v-col>
      </v-row>

      <hr style="border-top: solid 1px #E0E0E0;" class="m-b-4">

      <v-row class="profile-images-wrapper m-b-4">
        <v-col cols="6">
          <label>Profile images</label>
          <p class="p-t-2">The order that images appear <br> on your profile will be the same <br> as the order here.</p>
          <p class="p-t-2 p-b-2">Include product images to give <br> partner stores an understanding <br> of what you sell.</p>
        </v-col>
        <v-col cols="6" class="relative" style="margin-top: 48px;">
          <p class="small">Images {{ (settings.images.length + (settings.coco_profile_images && settings.coco_profile_images.length)) }}/{{ maxImagesAllowed }} <span>- You can add up to {{ maxImagesAllowed }} images (max 3mb)</span></p>
          <template v-if="!loading">
            <div class="upload-layer absolute"
            :class="{
              'move-to-top': (settings.images.length > 0 || settings.coco_profile_images.length > 0),
              'd-none': (settings.images && settings.coco_profile_images && (settings.images.length + settings.coco_profile_images.length) >= maxImagesAllowed) }">
              <input
                @change="handleFileUpload"
                accept="image/*"
                class="absolute upload-btn"
                multiple
                ref="fileInput"
                type="file"
              >
              <button class="btn btn-border lg" v-if="!loading">
                <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="m-r-1" style="transform: translateY(2px);">
                  <path d="M14.0852 15.6562H3.20021C2.89677 15.6439 2.59875 15.5718 2.32321 15.4441C2.04766 15.3164 1.79999 15.1357 1.59437 14.9122C1.38876 14.6887 1.22923 14.4268 1.12492 14.1416C1.0206 13.8564 0.973556 13.5534 0.986462 13.25V10.625C0.986462 10.451 1.0556 10.284 1.17867 10.161C1.30174 10.0379 1.46866 9.96875 1.64271 9.96875C1.81676 9.96875 1.98368 10.0379 2.10675 10.161C2.22982 10.284 2.29896 10.451 2.29896 10.625V13.25C2.27637 13.5098 2.35465 13.7683 2.51756 13.972C2.68048 14.1756 2.91553 14.3088 3.17396 14.3438H14.0852C14.3436 14.3088 14.5787 14.1756 14.7416 13.972C14.9045 13.7683 14.9828 13.5098 14.9602 13.25V10.625C14.9602 10.451 15.0294 10.284 15.1524 10.161C15.2755 10.0379 15.4424 9.96875 15.6165 9.96875C15.7905 9.96875 15.9574 10.0379 16.0805 10.161C16.2036 10.284 16.2727 10.451 16.2727 10.625V13.25C16.2989 13.8584 16.0838 14.4526 15.6741 14.9033C15.2644 15.3539 14.6934 15.6245 14.0852 15.6562Z" fill="#0E3B4D"/>
                  <path d="M12.1428 5.15616C12.0566 5.15657 11.9712 5.13975 11.8915 5.10669C11.8119 5.07364 11.7396 5.02501 11.6791 4.96366L8.64281 1.92741L5.60656 4.96366C5.48216 5.07958 5.31762 5.14269 5.1476 5.13969C4.97759 5.13669 4.81538 5.06782 4.69514 4.94758C4.5749 4.82734 4.50603 4.66513 4.50303 4.49512C4.50003 4.3251 4.56314 4.16056 4.67906 4.03616L8.17906 0.536161C8.30211 0.413267 8.4689 0.344238 8.64281 0.344238C8.81672 0.344238 8.98351 0.413267 9.10656 0.536161L12.6066 4.03616C12.7295 4.15921 12.7985 4.326 12.7985 4.49991C12.7985 4.67382 12.7295 4.84061 12.6066 4.96366C12.546 5.02501 12.4737 5.07364 12.3941 5.10669C12.3145 5.13975 12.229 5.15657 12.1428 5.15616Z" fill="#0E3B4D"/>
                  <path d="M8.64258 11.2812C8.46923 11.279 8.30363 11.2091 8.18105 11.0865C8.05846 10.9639 7.98859 10.7983 7.98633 10.625V1C7.98633 0.825952 8.05547 0.659032 8.17854 0.535961C8.30161 0.41289 8.46853 0.34375 8.64258 0.34375C8.81663 0.34375 8.98355 0.41289 9.10662 0.535961C9.22969 0.659032 9.29883 0.825952 9.29883 1V10.625C9.29656 10.7983 9.22669 10.9639 9.10411 11.0865C8.98153 11.2091 8.81592 11.279 8.64258 11.2812V11.2812Z" fill="#0E3B4D"/>
                </svg>
                Upload images
              </button>
            </div>
          </template>

          <template>
            <v-row class="image-holder-row relative">
              <div class="loading-holder absolute d-flex" v-if="loading">
                <v-img v-if="loading" class="rotate" src="~@/assets/images/logo.svg" height="60px" contain></v-img>
              </div>

              <template v-if="settings.updated_at">
                <v-col cols="4" class="image-holder" v-for="(image, index) in settings.coco_profile_images" :key="image.image_url">
                  <div class="placeholder relative">
                    <span class="delete-image" @click="deleteFilesFromView(index)">
                      <TrashIcon />
                    </span>
                    <v-img width="155" height="155" aspect-ratio="4/3" contain :src="image.image_url"></v-img>
                  </div>
                </v-col>
                <v-col cols="4" class="image-holder" v-for="(image, index) in settings.images" :key="image.key + '_' + index">
                  <div class="placeholder relative">
                    <span @click="deleteFilesFromS3Handler(image, index)" class="delete-image">
                      <TrashIcon />
                    </span>
                    <v-img width="155" height="155" aspect-ratio="4/3" contain :src="image.Location"></v-img>
                  </div>
                </v-col>
                <v-col cols="4" class="image-holder" v-for="item in (maxImagesAllowed - (settings.coco_profile_images.length + settings.images.length))" :key="item">
                  <div class="placeholder"></div>
                </v-col>
              </template>

              <template v-else>
                <v-col cols="4" class="image-holder" v-for="(image, index) in settings.images" :key="image.key + '_' + index">
                  <div class="placeholder relative">
                    <span @click="deleteFilesFromS3Handler(image, index)" class="delete-image">
                      <TrashIcon />
                    </span>
                    <v-img width="155" height="155" aspect-ratio="4/3" contain :src="image.Location"></v-img>
                  </div>
                </v-col>
                <v-col cols="4" class="image-holder" v-for="item in (maxImagesAllowed - settings.images.length)" :key="item">
                  <div class="placeholder"></div>
                </v-col>
              </template>

            </v-row>
          </template>
        </v-col>
      </v-row>
    </v-form>

    <v-overlay :value="previewProfile" class="dialog dialog-disconnect profile-images-wrapper">
      <v-card light class="card-rounded not-a-link" width="769px">
        <div class="dialog-body pa-7 pt-3" style="background: #ffffff;">
          <div class="text-right">
            <v-icon size="30px" color="#0E3B4D" class="mt-1" @click="previewProfile = false">close</v-icon>
          </div>
          <v-row class="m-t-1">
            <v-col cols="6">
              <label>Profile preview</label>
              <p class="p-t-2">This is how your profile will <br> appear on the marketplace.</p>
              <p class="p-t-2 p-b-2">When other stores message <br> you, you'll receive an email with <br> their details and an optional <br> personal message.</p>
            </v-col>
            <v-col cols="6" class="d-flex justify-end">
              <div class="profile-card">
                <v-carousel v-if="previewProfileImages.length > 0" v-model="model" height="auto" style="background: rgba(244, 244, 244, 1);" :class="{ 'single-image' : previewProfileImages.length === 1 }">
                  <v-carousel-item v-for="(image, index) in previewProfileImages" :key="index">
                    <v-img v-if="image.image_url" width="290" height="224" aspect-ratio="4/3" contain :src="image.image_url"></v-img>
                    <v-img v-else width="270" height="224" aspect-ratio="4/3" contain :src="image"></v-img>
                  </v-carousel-item>
                </v-carousel>
                <div v-else style="width: 302.5px; height: 224px; background-color: rgba(244, 244, 244, 1); border-radius: 8px;"></div>

                <div class="profile-details m-t-2">
                  <h4 class="d-flex">
                    <span>{{ settings.brand_name }}</span>
                    <a
                      v-if="(settings.coco_social_media && settings.coco_social_media[0] && settings.coco_social_media[0].url !== '') || settings.social_media"
                      :href="(settings.coco_social_media && settings.coco_social_media[0]) ? settings.coco_social_media[0].url : settings.social_media"
                      target="_blank"
                      class="instagram-link">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.00014 3.89989C7.18923 3.89989 6.39654 4.14035 5.7223 4.59087C5.04806 5.04138 4.52255 5.68171 4.21223 6.43089C3.90191 7.18007 3.82072 8.00444 3.97892 8.79976C4.13712 9.59509 4.5276 10.3256 5.101 10.899C5.67439 11.4724 6.40494 11.8629 7.20027 12.0211C7.99559 12.1793 8.81996 12.0981 9.56914 11.7878C10.3183 11.4775 10.9586 10.952 11.4092 10.2777C11.8597 9.60349 12.1001 8.8108 12.1001 7.99989C12.1015 7.4611 11.9963 6.92736 11.7907 6.42933C11.5852 5.9313 11.2832 5.4788 10.9022 5.09781C10.5212 4.71683 10.0687 4.41488 9.5707 4.2093C9.07267 4.00372 8.53893 3.89857 8.00014 3.89989ZM8.00014 10.6699C7.47206 10.6699 6.95584 10.5133 6.51676 10.2199C6.07768 9.92653 5.73546 9.50954 5.53338 9.02166C5.33129 8.53378 5.27842 7.99693 5.38144 7.479C5.48446 6.96107 5.73876 6.48532 6.11216 6.11192C6.48557 5.73851 6.96132 5.48422 7.47925 5.3812C7.99717 5.27817 8.53402 5.33105 9.0219 5.53313C9.50978 5.73522 9.92678 6.07744 10.2202 6.51652C10.5135 6.9556 10.6701 7.47182 10.6701 7.99989C10.6701 8.70802 10.3888 9.38715 9.88811 9.88787C9.38739 10.3886 8.70827 10.6699 8.00014 10.6699ZM13.2301 3.72989C13.2301 3.92767 13.1715 4.12101 13.0616 4.28546C12.9517 4.44991 12.7955 4.57808 12.6128 4.65377C12.4301 4.72946 12.229 4.74926 12.035 4.71068C11.8411 4.67209 11.6629 4.57685 11.523 4.437C11.3832 4.29715 11.2879 4.11896 11.2494 3.92498C11.2108 3.731 11.2306 3.52994 11.3063 3.34721C11.3819 3.16448 11.5101 3.0083 11.6746 2.89842C11.839 2.78854 12.0324 2.72989 12.2301 2.72989C12.4954 2.72989 12.7497 2.83525 12.9372 3.02279C13.1248 3.21032 13.2301 3.46468 13.2301 3.72989ZM15.9401 4.72989C15.9692 3.48672 15.5055 2.28249 14.6501 1.37989C13.7524 0.51358 12.5476 0.0388495 11.3001 0.0598926C10.0001 -0.000107422 6.00014 -0.000107422 4.70014 0.0598926C3.45734 0.0329817 2.25391 0.496394 1.35014 1.34989C0.49477 2.25249 0.0310507 3.45672 0.0601367 4.69989C0.000136718 5.99989 0.000136718 9.99989 0.0601367 11.2999C0.0310507 12.5431 0.49477 13.7473 1.35014 14.6499C2.25391 15.5034 3.45734 15.9668 4.70014 15.9399C6.02014 16.0199 9.98014 16.0199 11.3001 15.9399C12.5433 15.969 13.7475 15.5053 14.6501 14.6499C15.5055 13.7473 15.9692 12.5431 15.9401 11.2999C16.0001 9.99989 16.0001 5.99989 15.9401 4.69989V4.72989ZM14.2401 12.7299C14.1044 13.0738 13.8994 13.3862 13.6379 13.6477C13.3765 13.9091 13.0641 14.1141 12.7201 14.2499C11.1677 14.5637 9.5807 14.6713 8.00014 14.5699C6.42289 14.6715 4.83914 14.5639 3.29014 14.2499C2.9462 14.1141 2.63381 13.9091 2.37235 13.6477C2.11088 13.3862 1.90591 13.0738 1.77014 12.7299C1.35014 11.6699 1.44014 9.16989 1.44014 8.00989C1.44014 6.84989 1.35014 4.33989 1.77014 3.28989C1.90208 2.94256 2.10559 2.62685 2.36745 2.36327C2.62931 2.09968 2.94368 1.89411 3.29014 1.75989C4.83914 1.44587 6.42289 1.33827 8.00014 1.43989C9.5807 1.33844 11.1677 1.44604 12.7201 1.75989C13.0641 1.89567 13.3765 2.10064 13.6379 2.3621C13.8994 2.62357 14.1044 2.93595 14.2401 3.27989C14.6601 4.33989 14.5601 6.83989 14.5601 7.99989C14.5601 9.15989 14.6601 11.6699 14.2401 12.7199V12.7299Z" fill="#0E3B4D"/>
                      </svg>
                    </a>
                  </h4>
                  <p class="country">
                    {{ (settings.location && settings.location.country) ? settings.location.country : settings.location }}
                  </p>
                  <p v-if="settings.num_of_products" class="published-products">
                    {{ settings.num_of_products }} published products
                  </p>
                  <p v-if="settings.website" class="website">
                    <a :href="settings.website" class="link link-underline" target="_blank">
                      Website
                      <IconNewTab />
                    </a>
                  </p>
                  <v-btn elevation="0" class="btn btn-border inverse lg">Message</v-btn>
                </div>
              </div>
            </v-col>
          </v-row>
        </div>
      </v-card>
    </v-overlay>
  </section>
</template>

<style lang="scss">
  .marketplace-settings {
    max-width: 1024px;
    margin: 0 auto;

    label {
      font-size: 16px;
      line-height: 24px;
      font-weight: 600;
    }

    .actions {
      right: 0;
      top: 20px;

      .btn {
        min-width: 69px !important;
        height: 38px !important;
        font-size: 14px !important;
      }
    }

    form {
      .col > label {
        display: block;
        margin-top: 7px;
      }
    }
  }

  .profile-images-wrapper {
    label {
      font-size: 20px;
    }

    p {
      font-size: 16px;
      color: #767676;
    }

    .small {
      font-size: 12px;
    }
  }

  .image-holder-row {
    margin: -4px;
  }

  .loading-state {
    left: 50%;
    margin-left: -30px;
    margin-top: -30px;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
    width: 50px;
    z-index: 3;
  }

  .loading-holder {
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 3;
    background: rgba(255,255,255,.75);
  }

  .image-holder {
    padding: 4px;

    .placeholder {
      align-items: center;
      background: #e5e5e5;
      display: flex;
      height: 154px;
      justify-content: center;
    }

    .delete-image {
      cursor: pointer;
      height: 17px;
      width: 14px;
      position: absolute;
      right: 12px;
      top: 10px;

      svg {
        position: relative;
        z-index: 2;
      }

      path {
        fill: #B33A21;
      }

      &::before {
        content: '';
        width: 28px;
        height: 28px;
        border-radius: 12px;
        background: #ffffff;
        position: absolute;
        z-index: 1;
        left: 50%;
        top: 50%;
        transform: translateX(-50%) translateY(-50%);
      }
    }
  }

  .upload-layer {
    width: calc(100% - 24px);
    height: calc(100% - 24px);
    left: 12px;
    top: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 3;

    .upload-btn {
      cursor: pointer;
      height: 100%;
      left: 0;
      top: 0;
      width: 100%;
      opacity: 0;
    }

    .btn-border {
      pointer-events: none;
    }

    &.move-to-top {
      width: 202px;
      height: 45px;
      top: -15px;
      right: -12px;
      left: auto;
      transform: scale(.75);
    }
  }

  .profile-details {
    h4 {
      font-size: 15px;
      font-weight: normal;

      > span {
        display: inline-block;
        margin-right: 10px;
        word-break: break-all;
      }
    }

    .country,
    .published-products {
      font-size: 14px;
      color: rgba(118, 118, 118, 1);
    }

    .btn-border {
      border-radius: 6px;
      width: 98px;
      margin-top: 4px;
    }

    .instagram-link {
      display: inline-block;
      transform: translateY(3px);
    }
  }
</style>
